import { render, staticRenderFns } from "./LicenseCardList.vue?vue&type=template&id=049bb53c"
import script from "./LicenseCardList.vue?vue&type=script&lang=js"
export * from "./LicenseCardList.vue?vue&type=script&lang=js"
import style0 from "./LicenseCardList.vue?vue&type=style&index=0&id=049bb53c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports